import 'styled-components';

const theme = {
	fontFamily: 'Open Sans, JakartaSans, sans-serif',
	breakpoints: {
		sm: '576px',
		md: '768px',
		lg: '992px',
		xl: '1200px',
		xxl: '1400px',
	},
	containers: {
		sm: '540px',
		md: '720px',
		lg: '900px',
		xl: '1200px',
		xxl: '1400px',
	},
	styles: {
		boxShadow: {
			default: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
		},
		boxRounded: {
			default: '10px',
			large: '25px',
		},
	},
	colors: {
		erik: {
			red: 'rgba(218, 56, 51)',
			blue: 'rgba(35, 84, 160)',
			green: '#4CAF50',
			mix: '#7F466A',
			silver: 'rgba(192,192,192)',
			veryLightGray: '#eaeaea',
		},
		white: '#FFFFFF',
		grey: '#d8d8d8',
		dark: '#0F172A',
		gray: 'rgb(164, 164, 164)',
		red: '#d0021b',
		error: {
			red500: '#F56565',
		},
		button: {
			primary: {
				dark: '#0F172A',
			},
		},
	},
	fontSize: {
		desktop: {
			priceLarge: '26px',
			spanSmall: '18px',
			h1: '44px',
			h2: '36px',
			h3: '32px',
			h4: '28px',
			h5: '24px',
			h6: '18px',
			h7: '14px',
			subtitle: '18px',
			paragraph1: '16px',
			paragraph2: '14px',
			link1: '16px',
			link2: '14px',
			caption: '12px',
			text1: '13px',
			text2: '11px',
		},
	},
	boxShadow: {
		default: '-3px -3px 6px rgba(255, 255, 255, 0.6), 3px 3px 6px rgba(0, 0, 0, 0.1), inset 0 0 15px rgba(255, 255, 255, 0.5)',
		hover: '-3px -3px 6px rgba(255, 255, 255, 1), 3px 3px 6px rgba(0, 0, 0, 0.3), inset 0 0 15px rgba(255, 255, 255, 1)',
	},
	borderRadius: {
		small: '2px',
		default: '12px',
	},
};

export type ThemeType = typeof theme;

declare module 'styled-components' {
	//@ts-ignore
	export interface DefaultTheme extends ThemeType {}
}

export default theme;
